import LoginTherapistView from "./LoginTherapistView";

export const LoginTherapistContainer = () => {
  return (
    <div>
      <LoginTherapistView />
    </div>
  );
};
